import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import userGroup from "../../../../assets/icons/userGroup.svg";
import Selects from "../../../../biblio/Selects/Selects";
import { setOtpId } from "../../../../apis/slices/recipientSlice";
import { AppDispatch } from "../../../../apis/store";

interface SwitchAccountSelectProps {
  relatedAccounts: any[];
  accountsNumber?: number;
}

// switching account always lands on "تجديد كفالاتي" (s3), same as sponsor login
export const SwitchAccountSelect = ({
  relatedAccounts,
  accountsNumber,
}: SwitchAccountSelectProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const handleSelectChange = (value: any) => {
    dispatch(setOtpId(value?.value));
    navigate("/profile", { state: { selectedKey: "s3" } });
  };
  return (
    <div className="takaful---select-switch-account">
      <Selects
        allowClear={false}
        style={{ width: "100%" }}
        popupMatchSelectWidth={220}
        options={relatedAccounts}
        className="takaful--custom-select-switch"
        selectPlaceholder="إنتقل إلى حساب آخر"
        popupClassName="takaful--select-dropdown"
        onChange={handleSelectChange}
      />
      <img src={userGroup} alt="User Group" className="takaful--custom-icon" />
      <div className="takaful--custom-badge">{accountsNumber}</div>
    </div>
  );
};
